export default {
    passwordChange: {
        oldPass: "Старий пароль",
        newPass: "Новий пароль",
        change: "Змінити",
    }
};
